import React from 'react';
import { Item as StatelyItem } from 'react-stately';
import { ItemProps } from '../Item';

export interface BaseItemProps<T, L extends React.ElementType>
  extends ItemProps<T> {
  linkComponent: L;
}

export type LinkItemProps<T, L extends React.ElementType> = BaseItemProps<
  T,
  L
> &
  Omit<React.ComponentPropsWithoutRef<L>, keyof BaseItemProps<T, L>>;

const LinkItem = StatelyItem as <T, L extends React.ElementType>(
  props: LinkItemProps<T, L>,
) => React.ReactElement | null;

export default LinkItem;
